import { TAG_API_PATH } from 'constants/api';
import { FetchResult } from 'type/apiType';
import { TagInterface } from 'type/tagType';
import { ApiService } from './apiService';

class TagApiService extends ApiService<TagInterface> {
  public async fetchAllTags(): Promise<TagInterface[]> {
    let currentPage = 1;
    const pageSize = 300;
    let hasNext = true;

    const { results, page_next: nextPage } = await this.fetch(
      new URLSearchParams({ page_size: pageSize.toString(), page: currentPage.toString() })
    );

    const mergedData: TagInterface[] = results;
    hasNext = nextPage !== null;

    while (hasNext) {
      ++currentPage;
      const { results, page_next: nextPage } = await this.fetch(
        new URLSearchParams({ page_size: pageSize.toString(), page: currentPage.toString() })
      );
      hasNext = nextPage !== null;
      mergedData.push(...results);
    }
    return mergedData;
  }

  public async fetchTagList(params: URLSearchParams): Promise<FetchResult<TagInterface>> {
    return await this.fetch(params);
  }
}

export const tagApiService = new TagApiService(TAG_API_PATH);
